import React, { useState, useEffect, useRef } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import OwnRoutes from './Own/OwnRoutes';
import TeamRoutes from './Team/TeamRoutes';
import { useGetTeamAccess, useCheckUserPermission } from '@hooks';
import { HrScoringNavigation } from './Navigation/HrScoringNavigation';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const HrScoringRoute = ({ t }) => {
  const [employeeCanViewTeam, setEmployeeCanViewTeam] = useState(false);
  const [employeeAllowAddScoreTeam, setEmployeeAllowAddScoreTeam] = useState(false);
  // Navigate
  const [teamEmployeeList, setEmployeeList] = useState([]);
  const [teamAccessLoaded, setTeamAccessLoaded] = useState(false);

  const navigate = useNavigate();
  const redirectTriggeredRef = useRef(false);

  // Fetch team access
  const { data, isLoading: isEmployeeLoading } = useGetTeamAccess();

  useEffect(() => {
    if (data) {
      setEmployeeCanViewTeam(data?.data?.show_team_tab ?? false);
      setEmployeeAllowAddScoreTeam(data?.data?.is_add_score_allow ?? false);
      setEmployeeList(data?.data?.list?.employee_list ?? []);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmployeeLoading && data) setTeamAccessLoaded(true);
  }, [isEmployeeLoading, data]);

  // Permission check
  useCheckUserPermission(
    ['hr-scoring.index'],
    () => {},
    (error) => {
      if (error?.data?.redirect === true && !redirectTriggeredRef.current) {
        redirectTriggeredRef.current = true;
        toast.error(error.message);
        navigate('/dashboard', { replace: true });
      }
    }
  );

  // Block unauthorized team URL access
  useEffect(() => {
    if (!teamAccessLoaded) return;
    if (redirectTriggeredRef.current) return;

    const path = window.location.pathname;

    const teamURL =
      path.includes('/hr-scoring/team/table') ||
      path.includes('/hr-scoring/team/graph');

    if (!employeeCanViewTeam && teamURL) {
      redirectTriggeredRef.current = true;
      toast.error(t('page.hr_scoring_do_not_accees_this_url'));
      navigate('/dashboard', { replace: true });
    }
  }, [teamAccessLoaded, employeeCanViewTeam]);

  if (isEmployeeLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <HrScoringNavigation
            t={t}
            employeeCanViewTeam={employeeCanViewTeam}
          />
        }>
        {TeamRoutes({ t, teamEmployeeList, employeeAllowAddScoreTeam })}
        {OwnRoutes({ t })}
      </Route>

      {/** 404 fallback */}
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

HrScoringRoute.propTypes = {
  t: PropTypes.func
};

export default HrScoringRoute;
